import { useCmsVersion } from './store'
import type { ReactNode } from 'react'

export function CmsProvider({ children }: { children: ReactNode }) {
  const version = useCmsVersion()

  return (
    <div className="contents" data-cms-version={version}>
      {children}
    </div>
  )
}
